import { useState } from "react";
import { X } from "lucide-react";

const PHOTOS = [
  {
    url: "https://customer-assets.emergentagent.com/job_372d2d44-3a54-4a7a-9e26-4e2b8f432aad/artifacts/rsnjvekx_WhatsApp%20Image%202026-04-15%20at%2008.06.27.jpeg",
    alt: "Guincho transportando caminhonete",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_372d2d44-3a54-4a7a-9e26-4e2b8f432aad/artifacts/ffii5vkm_WhatsApp%20Image%202026-04-15%20at%2008.06.26-4.jpeg",
    alt: "Guincho transportando veiculo na cidade",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_372d2d44-3a54-4a7a-9e26-4e2b8f432aad/artifacts/qxr7sdrv_WhatsApp%20Image%202026-04-15%20at%2008.06.26-3.jpeg",
    alt: "Guincho transportando maquinario agricola",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_372d2d44-3a54-4a7a-9e26-4e2b8f432aad/artifacts/mytm0fmq_WhatsApp%20Image%202026-04-15%20at%2008.06.26.jpeg",
    alt: "Guincho transportando trator",
  },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState(null);

  return (
    <section
      id="galeria"
      data-testid="gallery-section"
      className="py-24 sm:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-[#FFD700] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest mb-6">
            Trabalhos Realizados
          </div>
          <h2
            data-testid="gallery-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-4"
            style={{ fontFamily: "'Oswald', sans-serif" }}
          >
            Nossos <span className="text-[#FFD700]">atendimentos</span>
          </h2>
          <p className="text-gray-400 text-base max-w-lg mx-auto">
            Confira alguns atendimentos realizados pela nossa equipe com
            seguranca e eficiencia.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
          {PHOTOS.map((photo, i) => (
            <div
              key={i}
              data-testid={`gallery-photo-${i}`}
              className="relative overflow-hidden border border-[#27272A] rounded-sm cursor-pointer group"
              onClick={() => setLightbox(photo)}
            >
              <img
                src={photo.url}
                alt={photo.alt}
                loading="lazy"
                className="gallery-img w-full h-64 sm:h-80 object-cover"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-end">
                <div className="p-4 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="text-sm font-medium text-white bg-black/60 px-3 py-1 rounded-sm">
                    {photo.alt}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          data-testid="gallery-lightbox"
          className="fixed inset-0 z-[60] bg-black/95 flex items-center justify-center p-4"
          onClick={() => setLightbox(null)}
        >
          <button
            onClick={() => setLightbox(null)}
            className="absolute top-6 right-6 text-white hover:text-[#FFD700] transition-colors"
            data-testid="lightbox-close"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={lightbox.url}
            alt={lightbox.alt}
            className="max-w-full max-h-[85vh] object-contain animate-scale-in"
          />
        </div>
      )}
    </section>
  );
}
